<!-- 研发型订单服务规则对话框 -->
<template>
  <el-dialog
    :visible.sync="visible"
    width="640px"
    :show-close="true"
    custom-class="order-rule-dialog"
    @close="handleClose"
  >
    <div class="dialog-content">
      <h3 class="dialog-title">研发型订单服务规则详情</h3>
      <div class="rule-table-wrapper">
        <table class="rule-table">
          <thead>
            <tr>
              <th class="col-category"><div class="cell">分类</div></th>
              <th class="col-type"><div class="cell"><strong>研发型</strong>（自助极速）</div></th>
              <th class="col-type"><div class="cell"><strong>标准型</strong>（人工护航）</div></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="col-category"><div class="cell">下单类型</div></td>
              <td><div class="cell">PCB在华秋定制 + BOM自助匹配选型</div></td>
              <td><div class="cell">无限制</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">PCB尺寸</div></td>
              <td><div class="cell">50mm*50mm - 150mm*220mm</div></td>
              <td><div class="cell">无限制</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">PCB层数</div></td>
              <td><div class="cell">仅限2、4层</div></td>
              <td><div class="cell">1-32层</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">下单数量</div></td>
              <td><div class="cell">5PCS 或者 10PCS 全贴</div></td>
              <td><div class="cell">不限数量</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">板厚限制</div></td>
              <td><div class="cell">1.6mm</div></td>
              <td><div class="cell">0.2 ~ 5mm自选</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">物料种类(BOM)</div></td>
              <td><div class="cell">≤60种</div></td>
              <td><div class="cell">无限制</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">客供物料占比</div></td>
              <td><div class="cell">≤15% (按行数计)</div></td>
              <td><div class="cell">不限制客供数量</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">封装要求</div></td>
              <td><div class="cell">无0201以下焊盘（不含0201）、无0.4以下pitchBGA/QFN（不含0.4）</div></td>
              <td><div class="cell">支持全类别封装</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">人工选型服务</div></td>
              <td class="text-danger"><div class="cell">无（系统自动匹配）</div></td>
              <td><div class="cell">全人工报价与选型</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">IQC实物核对</div></td>
              <td class="text-danger"><div class="cell">不核对</div></td>
              <td><div class="cell">100%工程师核对</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">生产异常处理</div></td>
              <td class="text-danger"><div class="cell">直接空贴</div></td>
              <td><div class="cell">人工电话沟通</div></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="rule-tips">
        <span><img class="warning-icon" src="@@/assets/img/icons/icon_warning.png" />特别说明：研发型订单通过全自动化流程实现极速交付。选择该模式即代表您认可系统自动解析结果，并自行承担因BOM封装不匹配导致的"自动空贴"风险。</span>
      </div>
      <div class="dialog-footer">
        <div class="btn-confirm" @click="handleConfirm">我已了解规则</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'OrderRuleDialog',
  props: {
    // 控制对话框显示/隐藏
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleConfirm() {
      this.visible = false
      this.$emit('confirm')
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .order-rule-dialog {
  .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
    font-size: 18px;
    .el-dialog__close {
      color: #909399;
    }
  }
}

.dialog-content {
  padding: 20px 24px 24px;
}

.dialog-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 16px 0;
}

.rule-table-wrapper {
  border: 1px solid #F2F3F5;
  border-radius: 4px;
  overflow: hidden;
}

.rule-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: #333333;

  thead {
    background-color: #f8f9fc;
  }

  th, td {
    text-align: center;
    border-bottom: 1px solid #F2F3F5;
    border-right: 1px solid #F2F3F5;

    &:last-child {
      border-right: none;
    }
  }

  th .cell {
    min-height: 48px;
    padding: 6px 12px;
    line-height: 20px;
    font-weight: 500;
    color: #303133;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  td .cell {
    min-height: 40px;
    padding: 6px 12px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .col-category {
    width: 120px;
    text-align: center;
    font-weight: 500;
    color: #666666;
  }

  .col-type {
    width: 220px;
  }

  .text-danger {
    color: #f56c6c;
  }
}

.rule-tips {
  margin-top: 12px;
  padding: 10px 12px;
  background-color: #FFF9F3;
  border-radius: 4px;
  font-size: 12px;
  color: #AD8C6D;
  line-height: 1.6;
  display: flex;
  align-items: flex-start;

  .warning-icon {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    margin-top: -1px;
  }

  span {
    flex: 1;
  }
}

.dialog-footer {
  margin-top: 20px;
  text-align: right;

  .btn-confirm {
    display: inline-block;
    width: 120px;
    height: 32px;
    line-height: 32px;
    background: #15a675;
    border-radius: 16px;
    background-color: #15A675;
    border-color: #15A675;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;

    &:hover, &:focus {
      background-color: #128d64;
      border-color: #128d64;
    }

    &:active {
      background-color: #128d64;
      border-color: #128d64;
    }
  }
}
</style>